import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=0dd28a6a&scoped=true"
import script from "./MessageCell.vue?vue&type=script&lang=js"
export * from "./MessageCell.vue?vue&type=script&lang=js"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=0dd28a6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd28a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd28a6a')) {
      api.createRecord('0dd28a6a', component.options)
    } else {
      api.reload('0dd28a6a', component.options)
    }
    module.hot.accept("./MessageCell.vue?vue&type=template&id=0dd28a6a&scoped=true", function () {
      api.rerender('0dd28a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/MessageCell.vue"
export default component.exports